import React, { PropTypes } from 'react/addons';
import cx from 'classnames';

import RawTether from 'ofs/react/RawTether';

import createPortal from './createPortal';

const Popover = React.createClass({
  propTypes: {
    closing: PropTypes.bool,

    children: PropTypes.node.isRequired,
    attachTo: PropTypes.object.isRequired, // TODO validated dom element
  },

  getInitialState() {
    return {
      panelClasses: [],
      anchorClasses: [],
      opened: false,
    };
  },

  getAnchorOptions() {
    return {
      element: this.refs.anchor.getDOMNode(),
      target: this.props.attachTo.getDOMNode(),
      attachment: 'top center',
      onPosition: this.onAnchorPosition,
      targetAttachment: 'bottom center',
      offset: '5px 0'
    };
  },

  getPanelOptions() {
    const { attachTo } = this.props;

    const panel = this.refs.panel.getDOMNode();
    const target = attachTo.getDOMNode();

    const panelRect = panel.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();

    let panelAttachment = 'top center';
    let targetAttachment = 'bottom center';

    // if there is no space to fit popover in window change attachment
    if (targetRect.left + (targetRect.width / 2) - (panelRect.width / 2) < 0) {
      panelAttachment = 'top left';
      targetAttachment = 'bottom left';
    }

    // if panel is bigger than window then always center attachment
    if (panelRect.width > window.innerWidth) {
      panelAttachment = 'top center';
      targetAttachment = 'bottom center';
    }

    return {
      element: panel,
      target: target,
      onPosition: this.onPanelPosition,
      offset: '-10px 0',
      attachment: panelAttachment,
      targetAttachment: targetAttachment,
    };
  },

  onAnchorPosition(position, elementClasses) {
    const anchorStyle = {
      top: position.page.top,
      left: position.page.left
    };
    this.setState({anchorStyle, anchorClasses: elementClasses});
  },

  onPanelPosition(position, elementClasses) {
    const panelStyle = {
      top: position.page.top,
      left: position.page.left
    };
    this.setState({panelStyle, panelClasses: elementClasses});
  },

  componentDidMount() {
    // Make sure that the input element is mounted correctly in the dom
    this._panelTether = new RawTether(this.getPanelOptions());
    this._anchorTether = new RawTether(this.getAnchorOptions());

    this._panelTether.enable();
    this._anchorTether.enable();
    /* eslint-disable react/no-did-mount-set-state */
    this.setState({
      opened: true
    });
    /* eslint-enable react/no-did-mount-set-state */
  },

  componentWillUnmount() {
    if (this._panelTether) {
      this._panelTether.disable();
    }
    if (this._anchorTether) {
      this._anchorTether.disable();
    }
  },

  render() {
    const { children, closing } = this.props;
    const { opened, panelClasses, anchorClasses, panelStyle, anchorStyle } = this.state;

    const _panelClasses = panelClasses.map(c => 'ofs-Popover__Panel--' + c);
    const _anchorClasses = anchorClasses.map(c => 'ofs-Popover__Anchor--' + c);
    _panelClasses.unshift('ofs-Popover__Panel');
    _anchorClasses.unshift('ofs-Popover__Anchor');

    if (closing) {
      _panelClasses.unshift('ofs-Popover__Panel--closing');
      _anchorClasses.unshift('ofs-Popover__Anchor--closing');
    }

    if (opened) {
      _panelClasses.unshift('ofs-Popover__Panel--opened');
      _anchorClasses.unshift('ofs-Popover__Anchor--opened');
    }

    return (
      <div className="ofs-Popover">
        <div ref="panel" className={cx.apply(null, _panelClasses)}
          style={panelStyle}>
          {children}
        </div>
        <div ref="anchor" className={cx.apply(null, _anchorClasses)}
          style={anchorStyle} />
      </div>
    );
  }
});

export default createPortal(Popover);



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/layers/PopoverNext.jsx
 **/